import type { ParticipantDocument, ParticipantFile } from '@piccolohealth/pbs-common';
import { ChakraV3 } from '@piccolohealth/ui';
import React from 'react';
import { FaRegTrashAlt } from 'react-icons/fa';
import { showModal } from '../../components/generic/Modal';
import { usePermission } from '../../hooks/usePermission';
import { ParticipantFilesAndDocumentsDeleteModal } from './ParticipantFilesAndDocumentsDeleteModal';

interface Props {
  participantId: string;
  selectedRows: (ParticipantFile | ParticipantDocument)[];
}

export const ParticipantFilesAndDocumentsDeleteMenuItem = (props: Props) => {
  const { participantId, selectedRows } = props;

  const hasDeleteFilePermission = usePermission('delete', 'participantFile');
  const hasDeleteDocumentPermission = usePermission('delete', 'participantDocument');
  const hasPermission = hasDeleteFilePermission && hasDeleteDocumentPermission;

  return (
    <ChakraV3.MenuItem
      onClick={() =>
        showModal(ParticipantFilesAndDocumentsDeleteModal, {
          participantId,
          selectedRows,
        })
      }
      value='delete'
      disabled={!hasPermission || selectedRows.length === 0}
      data-pw='selectedReportsDeleteMenuItem'
      color='danger'
    >
      <FaRegTrashAlt />
      Delete {selectedRows.length} files or documents
    </ChakraV3.MenuItem>
  );
};
